// Atlas block categories — 20 pedagogical themes.
// Each block in the Atlas belongs to exactly ONE category.
// Order matters (matches the editorial reading flow).
export const ATLAS_CATEGORIES = [
  { key: "histoire",          label: "Histoire",              emoji: "📜" },
  { key: "geographie",        label: "Géographie",            emoji: "🌍" },
  { key: "terroir_geologie",  label: "Terroir & Géologie",    emoji: "🪨" },
  { key: "climat",            label: "Climat",                emoji: "☀️" },
  { key: "cepages",           label: "Cépages",               emoji: "🍇" },
  { key: "viticulture",       label: "Viticulture",           emoji: "🌿" },
  { key: "vinification",      label: "Vinification",          emoji: "🍷" },
  { key: "les_vins",          label: "Les Vins",              emoji: "🥂" },
  { key: "climats_crus",      label: "Climats & Crus",        emoji: "🏞️" },
  { key: "accords",           label: "Accords Mets & Vins",   emoji: "🍽️" },
  { key: "producteurs",       label: "Producteurs",           emoji: "👨‍🌾" },
  { key: "patrimoine",        label: "Patrimoine & Culture",  emoji: "🏛️" },
  { key: "anecdotes",         label: "Anecdotes & Secrets",   emoji: "🎉" },
  { key: "chiffres_cles",     label: "Chiffres Clés",         emoji: "📊" },
  { key: "oenotourisme",      label: "Œnotourisme",           emoji: "🧳" },
  { key: "glossaire",         label: "Glossaire",             emoji: "📚" },
  { key: "saviez_vous",       label: "Le Saviez-vous ?",      emoji: "💡" },
  { key: "mythes",            label: "Mythes & Réalités",     emoji: "⚖️" },
  { key: "science",           label: "Science du Vin",        emoji: "🔬" },
  { key: "comparaisons",      label: "Comparaisons",          emoji: "🌎" },
];

export const CATEGORY_BY_KEY = Object.fromEntries(
  ATLAS_CATEGORIES.map((c) => [c.key, c])
);
